import {createApp} from 'vue'
import {createPinia} from 'pinia'
import App from './App.vue'
import {i18n} from "@/plugins/i18n.js";
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import HighchartsMore from "highcharts/highcharts-more";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import Start from "@/components/Start.vue";
import Result from "@/components/Result.vue";
import Question from "@/components/Question.vue";
import CrmForm from "@/components/CrmForm.vue";
import Final from "@/components/Final.vue";

const app = createApp(App)

// eslint-disable-next-line vue/multi-word-component-names
app.component('start', Start)
// eslint-disable-next-line vue/multi-word-component-names
app.component('result', Result)
// eslint-disable-next-line vue/multi-word-component-names
app.component('question', Question)
// eslint-disable-next-line vue/multi-word-component-names
app.component('crmform', CrmForm)
// eslint-disable-next-line vue/multi-word-component-names
app.component('final', Final)

app.component('v-select', vSelect)

app.use(createPinia())
app.use(i18n)

HighchartsMore(Highcharts);
app.use(HighchartsVue, {
  highcharts: Highcharts
})

app.mount('#app')
